import { Injectable, Inject } from '@angular/core';
import { HttpClient /*, HttpParams, HttpResponse */ } from '@angular/common/http';
import { Observable } from 'rxjs';
//import { Tc } from '../../../core/_infrastructure/types/common';
import {
    AltaUsuarioExternoViewModel,
    //AltaUsuarioExternoItemResultsViewModel,
    FilterSearchingVListaUsuariosExternosViewModel,
} from '../altausuariosexternos/altausuariosexternos.types';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { ResetFiltersService } from '../../../core/_infrastructure/classes/services/reset-filters.service';

@Injectable()
export class AltaUsuariosExternosService extends ResetFiltersService {
    public currentFilterUsuariosExternos = new FilterSearchingVListaUsuariosExternosViewModel();

    constructor(
        protected authService: AuthService,
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {
        super(authService);
    }
    getUsuarioExterno(id: number): Observable<AltaUsuarioExternoViewModel> {
        return this.http.get<AltaUsuarioExternoViewModel>(this.baseUrl + 'api/sede/asistente/getusuarioexternobyid/' + id).pipe();
    }

    createUsuario(usuario: AltaUsuarioExternoViewModel): Observable<any> {
        return this.http.post<AltaUsuarioExternoViewModel>(this.baseUrl + 'api/sede/asistente/', usuario).pipe();
    }

    //getUsuariosExternosPagedByFilter(params: HttpParams): Observable<AltaUsuarioExternoItemResultsViewModel> {
    //    return (
    //        this.http
    //            //Todo:agaro. IMPORTANTE!! /mantenimiento/ NOMBRE CONTROLLER / método. Si no, no coge la cabecera.
    //            .get<AltaUsuarioExternoItemResultsViewModel>(this.baseUrl + 'api/mantenimiento/usuario/pagedexternosbyfilter/', { params: params })
    //            .pipe()
    //    );
    //}

    //getPerfilesByIdUsuario(id: number): Observable<Tc[]> {
    //    return (
    //        this.http
    //            //Todo:agaro. IMPORTANTE!! /mantenimiento/ NOMBRE CONTROLLER / método. Si no, no coge la cabecera.
    //            .get<Tc[]>(this.baseUrl + 'api/mantenimiento/usuario/perfilesbyidusuario/' + id)
    //            .pipe()
    //    );
    //}

    //exportUsuariosExternos(model: FilterSearchingVListaUsuariosExternosViewModel): Observable<HttpResponse<Blob>> {
    //    return this.http
    //        .post(this.baseUrl + 'api/mantenimiento/usuario/postExportExcelByFilterUsuariosExternos', model, { observe: 'response', responseType: 'blob' })
    //        .pipe();
    //}

    resetFilter() {
        this.currentFilterUsuariosExternos = new FilterSearchingVListaUsuariosExternosViewModel();
    }
}
